import React from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';

import { CHART_RIGHT_SPACE_LEFT_PADDING, CHART_RIGHT_SPACE_WIDTH } from '../../../common/constants';
import {
	CHART_HEIGHT,
	CHART_SPACE_RIGHT,
	SELECTION_DETAIL_BOTTOM_PADDING,
} from '../../../common/ui/deployment-frequency-bar-chart/constants';
import { SkeletonItem, LineThin, LineThick } from '../../../common/ui/loading-skeleton';

export const LoadingSkeleton = () => (
	<Wrapper>
		<Box xcss={chartTitleStyles}>
			<SkeletonItem width={`${gridSize * 21}px`} height={`${gridSize * 2}px`} margin="0" />
		</Box>
		<ChartContainer>
			<ChartLeft>
				<SkeletonItem width={`${gridSize * 1.5}px`} height={`${gridSize * 16}px`} margin="0" />
			</ChartLeft>
			<Chart>
				<LineThin />
				<LineThin />
				<LineThin />
				<LineThin />
				<LineThick />
			</Chart>
			<SelectionDetail>
				<SkeletonItem
					width={`${gridSize * 14}px`}
					height={`${gridSize * 1.5}px`}
					margin={`0 0 ${gridSize * 1.5}px 0`}
				/>
				<SkeletonItem
					width={`${gridSize * 6.5}px`}
					height={`${gridSize * 2.5}px`}
					margin={`0 0 ${gridSize * 1.5}px 0`}
				/>
				<SkeletonItem
					width={`${gridSize * 26.5}px`}
					height={`${gridSize * 1.5}px`}
					margin={`0 0 ${gridSize * 1.5}px 0`}
				/>
				<SkeletonItem width={`${gridSize * 26.5}px`} height={`${gridSize}px`} margin="0" />
			</SelectionDetail>
		</ChartContainer>
	</Wrapper>
);

// eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({});

const chartTitleStyles = xcss({
	marginTop: 'space.200',
	height: 'space.300',
	paddingLeft: 'space.250',
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartContainer = styled.div<any>({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${CHART_HEIGHT}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ChartLeft = styled.div({
	width: token('space.500', '40px'),
	display: 'flex',
	alignItems: 'center',
	padding: `0 0 ${token('space.400', '32px')} ${token('space.250', '20px')}`,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Chart = styled.div<any>({
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `${token('space.200', '16px')} ${CHART_SPACE_RIGHT}px ${token('space.800', '64px')} 0`,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SelectionDetail = styled.div<any>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${CHART_RIGHT_SPACE_WIDTH}px`,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	padding: `0 0 ${SELECTION_DETAIL_BOTTOM_PADDING}px ${CHART_RIGHT_SPACE_LEFT_PADDING}px`,
});
